import React, { useState } from 'react';
import { FormattedDate } from 'react-intl'
import { Container, Row, Col, Button } from "react-bootstrap";
import { BfRowForm, BfButtonBlue } from '../../../Styling/styledForm/styledBlueForm'
import { StyledKfTable, StyledLink } from './../../../Styling/styledTable/StyledTable';
import { newDebitor, newDebitorWithAI } from "../../../reduxStore/newCase/newCaseActions"
import { useDispatch } from 'react-redux'
import styled from 'styled-components';
import { RatingCircle } from '../../../components/ratingCircle/RatingCircle';

const Circle = styled.button`    
    background: ${props => props.$primary || "white"};
    width: 23px;
    height: 23px;
    border-radius: 50%;
    border: 1px solid black;
`;

const ColumnsWrapper = styled.div`
  display: flex;
  width: 100%;
`;

const LeftColumn = styled.div`
  width: 50%;
  padding-right: 15rem;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    height: 95%;
    border-right: 1px solid #ccc;
  }

  p {
    font-size: 0.9em;
    margin-bottom: 1rem;
  }
`;

const RightColumn = styled.div`
  width: 50%;
  padding-left: 3rem;
  display: flex;
  flex-direction: column;
  justify-content: top;

  p {
    font-size: 0.9em;
    margin-bottom: 1rem;
    width: 60%;
  }
`;

const ArticleArea = styled.div`
  margin-bottom: 2rem;
  margin-top: 0;
  font-size: 25px;
  font-weight: 300;
  line-height: 33.6px;
  margin-bottom: 0px;
  font-family: "RM Neue", "sans-serif";
  color: #333;
  
  h1 {
    font-size: 1.5em;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }
  
  p {
    font-size: 0.9em;
    margin-bottom: 1rem;
  }
  
  ul {
    font-size: 0.9em;
    margin: 0;
    padding-left: 1rem;
    list-style: disc;
  }
`;

const DebitorList = (props) => {

  const localMessages = props.localeMessages
  const [filterValue, setFilterValue] = useState('')
  const dispatch = useDispatch()

  const printHeader = (t1IndicaterIcon, t1ChangeSortField) => {
    return (
      <thead>
        <tr>
          <th onClick={() => t1ChangeSortField('birthDate', 'string')}>{localMessages['GH_birthDate']}{t1IndicaterIcon('birthDate')}</th>
          <th onClick={() => t1ChangeSortField('debtorIdentificationNumber', 'string')}>{localMessages['GH_caseNumber']}{t1IndicaterIcon('debtorIdentificationNumber')}</th>
          <th onClick={() => t1ChangeSortField('debtorName', 'string')}>{localMessages['GH_debtorName']}{t1IndicaterIcon('debtorName')}</th>
          <th onClick={() => t1ChangeSortField('debtorNo', 'string')}>{localMessages['GH_debtorNo']}{t1IndicaterIcon('debtorNo')}</th>
          <th onClick={() => t1ChangeSortField('debtorRating', 'string')}>{localMessages['GH_creditScore']}{t1IndicaterIcon('debtorRating')}</th>
          <th onClick={() => t1ChangeSortField('ratingDate', 'datetime')}>{localMessages['GH_date_creditScore']}{t1IndicaterIcon('ratingDate')}</th>
          <th onClick={() => t1ChangeSortField('email', 'string')}>{localMessages['GH_email']}{t1IndicaterIcon('email')}</th>
          <th onClick={() => t1ChangeSortField('postalCode', 'string')}>{localMessages['GH_postalCode']}{t1IndicaterIcon('postalCode')}</th>
          <th onClick={() => t1ChangeSortField('postalPlace', 'string')}>{localMessages['GH_postalPlace']}{t1IndicaterIcon('postalPlace')}</th>
        </tr>
      </thead>
    )
  }

  const selectDebitor = model => {
    console.log('model selected', model)
    props.selectDebitor(model)
    // Skjuler info-knappen om man går via en valgt debitor pga de har allerede info på
    props.setGetInfoButtonVisible(false)
  }

  const setNewDebitor = () => {
      setFilterValue('')
      dispatch(newDebitor(false, localMessages))
  }

  const setNewDebitorWithAI = () => {
    setFilterValue('')
    dispatch(newDebitorWithAI(false, localMessages))
  }

  const printRow = (model) => {

    const DateOrBlank = (birthDate) => {

      if (!birthDate) {
        return ('')
      } else {
        return (
          <FormattedDate value={birthDate} day="2-digit" month="2-digit" year="numeric" />
        )
      }

    }

    const formatDate = (val) => {

      let splittedDate = val.replace(' ', '-').split('-');
      let splittedDay = splittedDate[2].replace(' ', 'T').split('T');
      let formattedDate = splittedDay[0] + '.' + splittedDate[1] + '.' + splittedDate[0];
      return formattedDate;

    }

    const asDate = (val) => {
      if (val !== null && val !== undefined) {
        let formattedDate = formatDate(val);
        return <span>{formattedDate}</span>;
      } else {
        return ''
      }
    }

    const checkTimeFromDate = (dateString) => {
      if (!dateString) {
        return '';
      }
      // Fjern [UTC] fra slutten av dateString ellers er det helt lotto om Javascript gjør den om til Date eller ikke.
      const dateStringWithoutUTC = dateString.replace('[UTC]', '');
      const date = new Date(dateStringWithoutUTC);
      const currentDate = new Date();

      const difference = currentDate.getTime() - date.getTime();
      const differenceInMonths = difference / (1000 * 60 * 60 * 24 * 30);

      if (differenceInMonths >= 6) {
        return 'NB! Over 6 mnd gammel';
      } else {
        return '';
      }
    };

    return (
      <tr key={model.i}>
        <td>{DateOrBlank(model.birthDate)}</td>
        <td>{model.debtorIdentificationNumber}</td>
        <td><StyledLink to="#" variant="link" onClick={() => selectDebitor(model)} >{model.debtorName}</StyledLink></td>
        <td>{model.debtorNo}</td>
        <td>
            <RatingCircle value={model.debtorRating} />
        </td>
        <td>
          <>
            {asDate(model.ratingDate)}
            {model.ratingDate && (
              <span style={{ marginLeft: '8px', fontWeight: 'bold' }}>
                {checkTimeFromDate(model.ratingDate)}
              </span>
            )}
          </>
        </td>
        <td>{model.email}</td>
        <td>{model.postalCode}</td>
        <td>{model.postalPlace}</td>
      </tr>

    )
  }

  return (
    <>
      <Container fluid="true">
        <ColumnsWrapper>
          <LeftColumn>
            <ArticleArea>
              <h1>{localMessages['arth']}</h1>
              <p>{localMessages['artd1']}
                <br/>{localMessages['artd2']}
              </p>
              <br/>
              <h1 style={{paddingTop:'20px'}}>{localMessages['gebyrHeader']}</h1>
              <ul>
                <li>{localMessages['gebyr1']}</li>
                <li>{localMessages['gebyr2']}</li>
                <li>{localMessages['gebyr3']}</li>
                <li>{localMessages['gebyr4']}</li>
              </ul>
              <br/>
            </ArticleArea>
          </LeftColumn>
          <RightColumn>
            {/* <ArticleArea>
              <h1>{localMessages['autoHeader']}</h1>
              <p>Vi jobber med forbedringer for automatisk avlesning, vennligst bruk manuell inntasting om du ønsker å registrere ny debitor.</p> */}
              {/* <p>{localMessages['autoP']}</p>
              <BfButtonBlue variant="primary" onClick={setNewDebitorWithAI}>
                {localMessages['autoButton']}
              </BfButtonBlue> */}
            {/* </ArticleArea> */}
            {/* <br/><br/> */}
            <ArticleArea>
              {/* <h1>{localMessages['manuellHeader']}</h1> */}
              <h1>Ny debitor</h1>
              <p>{localMessages['manuellP']}</p>
              <BfButtonBlue variant="primary" onClick={setNewDebitor}>
                {localMessages['manuellButton']}
              </BfButtonBlue>
            </ArticleArea>
          </RightColumn>
        </ColumnsWrapper>
      </Container>

      <Container fluid="true">
        <BfRowForm>
          <Col xs={12} md={12}>
            <props.PaginationDropdown />
            <StyledKfTable>
              {printHeader(props.t1IndicaterIcon, props.t1ChangeSortField)}

              <tbody>
                <props.Paginate>
                  {/* paginate forventer en funksjon */}
                  {row => printRow(row)}
                </props.Paginate>
              </tbody>
            </StyledKfTable>
            <br />
            <props.PaginationIndex />
            <br /><br />
            <props.PaginationNav />
          </Col>
        </BfRowForm>
      </Container>

    </>
  )
}

export default React.memo(DebitorList)



